import { apiDate, number, optional, optionalNumber, string, uuid, zodLess } from '@kaiizen/zod-less';

export const ApiPhotoSchema = zodLess({
  id: uuid,
  url: string,
  description: optional(string),
  mime: string,
  propertyId: uuid,
  itemId: optional(uuid),
  width: number,
  height: number,
  bytes: number,
  direction: optionalNumber,
  tags: optional([string]),
  createdAt: apiDate,
  updatedAt: apiDate,
}, {
  ref: 'photo',
  description: 'Photo record with metadata and file information',
});
